import React, { useContext, useState } from 'react';
import { Typography, IconButton, Button, Dialog, dialogClasses, DialogTitle, DialogActions, DialogContent, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { NotebookFeedbackCtx, notebookDefaultProperties, } from '../../App/ApplicationContext';
import { ParameterSelector } from './ParameterSelector';
import { DEFAULTCOORDINATES, NODATE, OPENDAPMETA, ROOKMETA, } from '../../../types/dataTypes';
import { Status, OUTPUT, } from '../../../types/searchTypes';
const classes = {
    root: {
        minWidth: '100%',
        minHeight: '50vh',
    },
    closeButton: {
        position: 'absolute',
        right: '4px',
        top: '4px',
        color: '#9e9e9e',
    },
    dialogDownloadPaper: {
        minHeight: '30vh',
        minWidth: '65vw',
    },
    dialogTitle: {
        color: '#fff',
        backgroundColor: '#3f51b5',
        fontWeight: 400,
    },
    dialogContent: {
        padding: '0px',
    },
    dialogFooter: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '8px',
        backgroundColor: '#f5f5f5',
    },
};
export const SubsettingForm = ({ setSubsetFormOpen, setSubsettingParameters, subsettingMode, }) => {
    const [temporalParameters, setTemporalParameter] = useState(NODATE);
    const [spatialParameters, setSpatialParameter] = useState(DEFAULTCOORDINATES);
    const [rookOperation, setRookOperation] = useState('average');
    const { notebookProperties, setNotebookProperties } = useContext(NotebookFeedbackCtx);
    const initiateProcessing = () => {
        const optionalTempParams = temporalParameters.start_time &&
            temporalParameters.stop_time &&
            temporalParameters;
        const optionalSpatParams = spatialParameters.minlat &&
            spatialParameters.minlon &&
            spatialParameters.maxlat &&
            spatialParameters.maxlon &&
            spatialParameters;
        const optionalRookOperation = rookOperation
            ? { operation: rookOperation }
            : null;
        const meta = rookOperation ? ROOKMETA : OPENDAPMETA;
        setSubsettingParameters(Object.assign(Object.assign(Object.assign(Object.assign({}, optionalTempParams), optionalSpatParams), optionalRookOperation), meta));
        setSubsetFormOpen(false);
        setNotebookProperties(Object.assign(Object.assign({}, notebookProperties), { processingStatus: Status.IDLE, redirectUrl: notebookProperties.redirectUrl, dialogOpen: true, output: OUTPUT.NOTEBOOK }));
    };
    return (React.createElement("div", { style: classes.root },
        React.createElement(Dialog, { "aria-labelledby": 'simple-dialog-title', open: true, sx: {
                [`& .${dialogClasses.paper}`]: classes.dialogDownloadPaper,
            }, fullWidth: true },
            React.createElement(DialogTitle, { id: 'simple-dialog-title', sx: classes.dialogTitle },
                React.createElement(Typography, { align: 'center' }, "Select Parameters"),
                React.createElement(IconButton, { "aria-label": 'Close', sx: classes.closeButton, onClick: () => {
                        setNotebookProperties(notebookDefaultProperties);
                        setSubsetFormOpen(false);
                    } },
                    React.createElement(CloseIcon, { style: { color: 'white' } }))),
            React.createElement(DialogContent, { sx: classes.dialogContent },
                React.createElement(ParameterSelector, Object.assign({}, {
                    temporalParameters,
                    setTemporalParameter,
                    spatialParameters,
                    setSpatialParameter,
                    subsettingMode,
                    rookOperation,
                    setRookOperation,
                }))),
            React.createElement(DialogActions, { sx: classes.dialogFooter },
                React.createElement(Button, { onClick: () => {
                        setNotebookProperties(notebookDefaultProperties);
                        setSubsetFormOpen(false);
                    }, color: 'secondary' }, "Close"),
                React.createElement(Button, { "aria-haspopup": 'true', color: 'primary', variant: 'outlined', onClick: () => {
                        initiateProcessing();
                    } }, "Process")))));
};
